import { useQuery } from '@tanstack/react-query';
import { vouchersService, FetchVouchersResponse } from '@aslanpay/portal-common-lib';

const DEFAULT_PAGE_SIZE = 500;

export function useFetchUserVouchers(individualId?: string) {
  return useQuery<FetchVouchersResponse, Error>(
    ['userVouchers', individualId],
    () =>
      vouchersService.fetchVouchers({
        individualIds: individualId ? [individualId] : [],
        providers: ['SPENDSTREAM'],
        pageNumber: 0,
        size: DEFAULT_PAGE_SIZE,
      }),
    {
      enabled: Boolean(individualId),
    }
  );
}

export default useFetchUserVouchers;
